import { defineStore } from "pinia";
import axios from "axios";

export const useRolesStore = defineStore("roles", {
  state: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
    roles: [],
    response: {
      status: null,
      message: null,
      error: [],
    },
  }),
  actions: {
    async getRoles() {
      try {
        const url = `${this.apiUrl}/api/v1/roles`;
        const res = await axios.get(url);
        this.roles = res.data.data.list;
      } catch (error) {
        this.error = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },
  },

  async addRoles(data) {
    try {
      const res = await axios.post(`${this.apiUrl}/api/v1/roles`, data);
      this.response = {
        status: res.status,
        message: res.data.message,
      };
    } catch (error) {
      this.response = {
        status: error.response?.status,
        message: error.message,
        list: error.response.data.errors,
      };
    }
  },

  async updateRoles(data) {
    try {
      const res = await axios.put(`${this.apiUrl}/api/v1/roles`, data);
      this.response = {
        status: res.status,
        message: res.data.message,
      };
    } catch (error) {
      this.response = {
        status: error.response?.status,
        message: error.message,
        list: error.response.data.errors,
      };
    }
  },

  async deleteRoles(id) {
    try {
      const res = await axios.delete(`${this.apiUrl}/api/v1/roles/${id}`);
      this.response = {
        status: res.status,
        message: res.data.message,
      };
    } catch (error) {
      this.response = {
        status: error.response?.status,
        message: error.message,
        list: error.response.data.errors,
      };
    }
  },
});
